module.exports = __webpack_public_path__ + "static/media/no-assessments.dd537160.svg";